import React from "react";

export type BannerVariant = "degraded" | "broken" | "closed";

interface Props {
  variant: BannerVariant;
  children: React.ReactNode;
}

const VARIANT_CLASS: Record<BannerVariant, string> = {
  degraded: "banner banner--degraded",
  broken: "banner banner--broken",
  closed: "banner banner--closed",
};

export function Banner({ variant, children }: Props): JSX.Element {
  const role = variant === "broken" ? "alert" : "status";
  return (
    <div role={role} className={VARIANT_CLASS[variant]}>
      {children}
    </div>
  );
}
